import { render, staticRenderFns } from "./UpdateMedicalSchool.vue?vue&type=template&id=0ddbf98c&scoped=true"
import script from "./UpdateMedicalSchool.vue?vue&type=script&lang=js"
export * from "./UpdateMedicalSchool.vue?vue&type=script&lang=js"
import style0 from "./UpdateMedicalSchool.vue?vue&type=style&index=0&id=0ddbf98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddbf98c",
  null
  
)

export default component.exports